/* eslint-disable no-unused-vars */
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React from "react";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function PSnackbar(props) {
  const [open, setOpen] = React.useState(false);
  const [type, setType] = React.useState(false);
  const [message, setMessage] = React.useState(false);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  props.biRef.snakbar = {
    showMessage: showMessage,
  };

  function showMessage(type, message) {
    console.log("Inside show Message");
    setType(type);
    setMessage(message);
    setOpen(true);
  }

  return (
    <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={type}>
        {message}
      </Alert>
    </Snackbar>
  );
}
